export default {"src":"/_next/static/media/pause.8c042ed4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};